import { useEffect, useState } from 'react';
import { useProduct } from 'frontastic';

const useParentReviewStats = (sku: string, isRefurbished: boolean) => {
  const { getProductBySku } = useProduct();
  const [parentReviewStats, setParentReviewStats] = useState<Record<string, any> | null>(null);

  useEffect(() => {
    const fetchParentReviewStats = async () => {
      try {
        const baseSku = isRefurbished ? sku.replace(/[a-zA-Z]+$/, '') : sku;
        const parentProduct = await getProductBySku(baseSku);
        setParentReviewStats(parentProduct?.reviewRatingStatistics || null);
      } catch (error) {
        console.error('Error fetching parent product review stats:', error);
        setParentReviewStats(null);
      }
    };

    fetchParentReviewStats();
  }, [sku, isRefurbished, getProductBySku]);

  return parentReviewStats;
};

export default useParentReviewStats;
